export default __webpack_public_path__ + "static/media/019-pancake.14ee0d92.svg";